var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCircleCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.835938,
    y: 1,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#353947"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4188 24.3212L14.258 21.1604C14.1008 21.0086 13.8903 20.9246 13.6718 20.9265C13.4533 20.9284 13.2443 21.016 13.0898 21.1705C12.9353 21.325 12.8476 21.534 12.8457 21.7525C12.8438 21.971 12.9278 22.1815 13.0796 22.3387L16.8296 26.0887C16.9859 26.2449 17.1978 26.3327 17.4188 26.3327C17.6398 26.3327 17.8517 26.2449 18.008 26.0887L27.1746 16.922C27.3264 16.7649 27.4104 16.5544 27.4085 16.3359C27.4066 16.1174 27.319 15.9084 27.1645 15.7538C27.01 15.5993 26.801 15.5117 26.5825 15.5098C26.364 15.5079 26.1535 15.5919 25.9963 15.7437L17.4188 24.3212Z",
    fill: "#353947"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCircleCheckmark);
export default __webpack_public_path__ + "static/media/BlackCircleCheckmark.22a18862c5b7e882c04b3e45e2639510.svg";
export { ForwardRef as ReactComponent };